export const barChartList = [
   {
      name: 'Swaroski',
      dataKey: 'Swaroski',
      color: '#3A0D6E',
      orderNumbers: 123817,
      orderSales: 561225,
   },
   {
      name: 'Swatch',
      dataKey: 'Swatch',
      color: '#AD96D6',
      orderNumbers: 87192,
      orderSales: 238611,
   },
   {
      name: 'Flik flak',
      dataKey: 'FlikFlak',
      color: '#CAB4E2',
      orderNumbers: 87192,
      orderSales: 238611,
   },
   {
      name: 'Villeroy & Boch',
      dataKey: 'VilleroyBoch',
      color: '#AD96D6',
      orderNumbers: 87192,
      orderSales: 238611,
   },
   {
      name: 'Sander',
      dataKey: 'Sander',
      color: '#CAB4E2',
      orderNumbers: 87192,
      orderSales: 238611,
   },
   {
      name: 'Mopita',
      dataKey: 'Mopita',
      color: '#CAB4E2',
      orderNumbers: 87192,
      orderSales: 238611,
   },
   {
      name: 'Bluekids',
      dataKey: 'Bluekids',
      color: '#CAB4E2',
      orderNumbers: 87192,
      orderSales: 238611,
   },
];


export const mainBrnadTableCol = [{
   label: '',
   field: 'title',
   align: 'left'
}, {
   label: 'Order Numbers',
   field: 'total_orders',
   align: 'left'
}, , {
   label: 'Order Sales',
   field: 'total_amount',
   align: 'left',
   cellComponent: ({ data }) => {
      return <span>{data}</span>
   }
}];


export const overviewOfCriticalSalesCol = [{
   label: 'Total Orders',
   field: 'total_orders',
   align: 'left'
}, {
   label: 'Total Revenue',
   field: 'total_revenue',
   align: 'left'
}, {
   label: 'Average Order Value',
   field: 'avg_order_value',
   align: 'left'
}, {
   label: 'Conversion Rate',
   field: 'conversion_rate',
   align: 'left'
}, {
   label: 'Return Rate',
   field: 'return_rate',
   align: 'left'
}, {
   label: 'Customer Satisfaction',
   field: 'customer_satisfaction',
   align: 'left',
   cellComponent: ({ data }) => {
      return <span>{data}</span>
   }
},];
export const overviewOfCriticalSalesData = [
   {
      total_orders: 0,
      total_revenue: '$0',
      avg_order_value: '$0',
      conversion_rate: '0%',
      return_rate: '0%',
      customer_satisfaction: '0/0',
   },
   {
      total_orders: 0,
      total_revenue: '$0',
      avg_order_value: '$0',
      conversion_rate: '0%',
      return_rate: '0%',
      customer_satisfaction: '0/0',
   },
   {
      total_orders: 0,
      total_revenue: '$0',
      avg_order_value: '$0',
      conversion_rate: '0%',
      return_rate: '0%',
      customer_satisfaction: '0/0',
   },
   {
      total_orders: 0,
      total_revenue: '$0',
      avg_order_value: '$0',
      conversion_rate: '0%',
      return_rate: '0%',
      customer_satisfaction: '0/0',
   },
   {
      total_orders: 0,
      total_revenue: '$0',
      avg_order_value: '$0',
      conversion_rate: '0%',
      return_rate: '0%',
      customer_satisfaction: '0/0',
   },
]
